
import Mdfe from "model/transportes/mdfe/Mdfe";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dialog } from "primereact/dialog";
import { useEffect, useState } from "react";
import MdfeService from "service/transportes/MdfeService";
import RotaService from "service/transportes/RotaService";

type Props = {
    visible: boolean;
    onHide: () => void;
    onConfirm: (coleta: Mdfe) => void;
}

const rotasService = new RotaService();
export default function ModalSelecionarMdfe(props: Props) {

    const [mdfes, setMdfes] = useState<Mdfe[]>([]);
    const [mdfeSelecionada, setMdfeSelecionada] = useState<Mdfe | null>(null);

    useEffect(() => {
        rotasService.mdfes().then((data) => {
            setMdfes(data);
        }).catch(err => {
            console.log(err);
        });
    }, [])

    const footer = <div>
        <Button label="Cancelar" icon="pi pi-times" className="p-button-text p-button-danger" onClick={props.onHide} />
        <Button label="Confirmar" icon="pi pi-check" className="p-button-text" onClick={() => mdfeSelecionada ? props.onConfirm(mdfeSelecionada) : null} />
    </div>

    return (
        <Dialog
            header="Selecione uma MDF-e"
            visible={props.visible}
            baseZIndex={500} style={{ width: '50vw' }}
            onHide={props.onHide} footer={footer}>
            <DataTable
                emptyMessage="Nenhum registro encontrado"
                value={mdfes}
                selectionMode="single"
                selection={mdfeSelecionada!}
                onSelectionChange={(e : any) => {
                    setMdfeSelecionada(e.value);
                }}
                dataKey={"id"}

            >
                <Column field="chMdfe" header="Conhecimento MDFE"/>
                <Column field="listVeicTracao.0.listCondutor.0.xnome" header="Condutor" />
                <Column field="listVeicTracao.0.placa" header="Placa" />
                <Column field="ufFim" header="Estado final" />
            </DataTable>

        </Dialog>
    );
}